import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Edit = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="edit icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M0.994505 22.7513L2.35763 17.9803C2.45101 17.6535 2.62613 17.3559 2.86647 17.1155L14.4393 5.54265L19.4393 10.5427L7.86647 22.1155C7.62613 22.3559 7.32851 22.531 7.00169 22.6244L2.23075 23.9875C1.4764 24.203 0.778975 23.5056 0.994505 22.7513Z"
    />
    <path
      className={pathClass}
      d="M21.5607 8.42134L23.5858 6.39621C24.3668 5.61516 24.3668 4.34883 23.5858 3.56779L21.4142 1.39621C20.6332 0.615162 19.3668 0.615163 18.5858 1.39621L16.5607 3.42133L21.5607 8.42134Z"
    />
  </svg>
)
